import React from 'react'
import { Link, graphql } from 'gatsby'
import Layout from '../components/Layout'
import SEO from '../components/seo'
import MySwiper from '../components/Swiper'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import WebriQForm from '@webriq/gatsby-webriq-form'


class IndexPage extends React.Component {
 
    
  render() {
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteDescription = this.props.data.site.siteMetadata.description

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title={siteTitle} description={siteDescription} />
        <div>
          <p>This is the homepage</p>
          <Link to="/blog">Go to Blog</Link>
          <br />
          <br />
          <h1>Sample Swiper</h1>
          <br />
          <MySwiper slidesperview={3}>
            <div><LazyLoadImage effect="blur" className="img-fluid" src="https://source.unsplash.com/collection/145698/400x400" alt=""/></div>
            <div><LazyLoadImage effect="blur" className="img-fluid" src="https://source.unsplash.com/collection/2203755/400x400" alt=""/></div>
            <div><LazyLoadImage effect="blur" className="img-fluid" src="https://source.unsplash.com/collection/362271/400x400" alt=""/></div>
            <div><LazyLoadImage effect="blur" className="img-fluid" src="https://source.unsplash.com/collection/3657445/400x400" alt=""/></div>
            <div><LazyLoadImage effect="blur" className="img-fluid" src="https://source.unsplash.com/collection/385548/400x400" alt=""/></div>
            <div><LazyLoadImage effect="blur" className="img-fluid" src="https://source.unsplash.com/collection/325867/400x400" alt=""/></div>
            <div><LazyLoadImage effect="blur" className="img-fluid" src="https://source.unsplash.com/collection/1118905/400x400" alt=""/></div>
            <div><LazyLoadImage effect="blur" className="img-fluid" src="https://source.unsplash.com/collection/2270935/400x400" alt=""/></div>
            <div><LazyLoadImage effect="blur" className="img-fluid" src="https://source.unsplash.com/collection/1252081/400x400" alt=""/></div>
            <div><LazyLoadImage effect="blur" className="img-fluid" src="https://source.unsplash.com/collection/2411320/400x400" alt=""/></div>
          </MySwiper>
          <br />
          <br />
          <h1>Sample Form</h1>
          <br />
						<div className="container">
							<div className="row">
								<div className="col-12 col-md-8 mt-4">
									<div className="contact-form">
										<WebriQForm
											name="Home Contact"
											method="POST"
											id="contact"
											data-form-id="b0354baf-6a25-4b4c-88d1-fced58e3403c"
                      data-thankyou-url="/thank-you"
                      scriptSrc="https://iv9rthvofk.execute-api.us-west-2.amazonaws.com/dev/js/initReactForms"
										>
											<div class="form-group">
                        <input
                          name="Testing"
													type="text"
													class="form-control"
													id="Name"
													aria-describedby="Name"
													placeholder="Name"
												/>
											</div>
											<div class="form-group">
                        <input
                          name="Email-Add"
													type="email"
													class="form-control"
													id="exampleInputEmail1"
													aria-describedby="Email"
													placeholder="Enter email"
												/>
											</div>
											<div class="form-group">
                        <input
                          name="subject"
													type="text"
													class="form-control"
													id="Subject"
													placeholder="Subject"
												/>
											</div>
											<div class="form-group">
                        <textarea
                          name="message"
													class="form-control"
													id="Message"
													rows="7"
													placeholder="Message"
												></textarea>
											</div>
											<div class="form-group">
												<div className="webriq-recaptcha mb-3" />
											</div>
											<button type="submit" class="btn btn-primary submit">
												Submit
											</button>
										</WebriQForm>
									</div>
								</div>
							</div>
						</div>
          
        </div>
      </Layout>
    )
  }
}

export default IndexPage

export const indexPageQuery = graphql`
  query indexPageQuery {
    site {
      siteMetadata {
        title
        author
        description
      }
    }
  }
`
